import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {inject} from '@angular/core';
import {Observable} from 'rxjs';
import {HelperService} from '../services/helper.service';
import {UserAuthenticationService} from '../services/user-authentication.service';

export class AuthInterceptor implements HttpInterceptor {
  private readonly userAuthService = inject(UserAuthenticationService);
  private readonly helperService = inject(HelperService);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!!request.headers.get('Authorization')) {
      return next.handle(request);
    }

    const userInfo = this.userAuthService.currentUserInfo;
    if (!userInfo.userName && !userInfo.userPW) {
      return next.handle(request);
    }

    const basicAuth = this.helperService.getSwissAuthorization(this.userAuthService.currentUserInfo);
    if (!!basicAuth) {
      request = request.clone({
        setHeaders: {
          Authorization: basicAuth,
        }
      });
    }

    return next.handle(request);
  }
}
